<template>
    <div>
        <v-autocomplete
                v-model="captain_model"
                :items="data"
                :label="label"
                :loading="loading"
                :search-input.sync="search"
                full-width
                cache-items
                clearable
                item-value="id"
                item-text="text"
                color="primary"
                placeholder="Start typing to Search"
                prepend-icon="mdi-database-search"
        >
            <template
                    slot="selection"
                    slot-scope="data"
            >
                <v-chip
                        :selected="data.selected"
                        close
                        class="chip--select-multi"
                >
                    <v-avatar>
                        <img :src="api.GET_IMAGE(data.item.profile_image)" alt="profile_image">
                    </v-avatar>
                    {{ data.item.first_name + " " + data.item.last_name }}
                </v-chip>
            </template>
            <template
                    slot="item"
                    slot-scope="data"
            >
                <v-list-tile-avatar>
                    <img :src="api.GET_IMAGE(data.item.profile_image)">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title
                            v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.username"></v-list-tile-sub-title>
                </v-list-tile-content>
            </template>
            <v-slide-x-reverse-transition
                    slot="append-outer"
                    mode="out-in"
            >
                <v-icon
                        :key="`icon-${isEditing}`"
                        :color="isEditing ? 'success' : 'info'"
                        @click="isEditing = !isEditing"
                        v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                ></v-icon>
            </v-slide-x-reverse-transition>
        </v-autocomplete>
        <div v-if="cars && cars.length > 0">
            <v-list>
                <v-list-tile-title class="title text-sm-center">Cars</v-list-tile-title>
                <v-list-tile v-for="car of cars" @click="handleCarInput(car.id)">
                    <v-list-tile-action>
                        <v-checkbox :value="model.indexOf(car.id) !== -1"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Number: {{car.number}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{car.color}} {{car.brand}} {{car.model}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </div>
        <div v-if="model.length > 0">
            <v-list>
                <div class="title">
                    Selected Cars
                    <v-list-tile-title class="title text-sm-center">Cars</v-list-tile-title>
                    <v-list-tile v-for="car of carsArchive" @click="">
                        <v-list-tile-action>
                            <v-icon>close</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content @click="handleCarInput(car.id)">
                            <v-list-tile-title>Number: {{car.number}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{car.color}} {{car.brand}} {{car.model}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>{{car.captain}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </div>
            </v-list>
        </div>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import _ from "lodash";

    export default {
        name: "choose-cars",
        components: {LoadingComponent},
        props: {
            label: String,
            value: '',
            initialSearchParams: {
                type: URLSearchParams,
                default: () => new URLSearchParams()
            },
        },
        data() {
            return {
                isEditing: false,
                loading: false,
                captain_model: this.value,
                search: null,
                data: [],
                cached: [],
                cars: null,
                model: [],
                archive: {}
            }
        },
        computed: {
            carsArchive() {
                return this.model.map(itemId => this.archive[itemId]);
            }
        },
        methods: {
            handleCarInput(carId) {
                if (this.model.indexOf(carId) === -1) {
                    this.model = [...this.model, carId];
                    this.archive = {
                        ...this.archive,
                        [carId]: this.cars.filter(({id}) => id.toString() === carId.toString())[0]
                    };
                } else {
                    this.model = this.model.filter(id => id !== carId);
                    this.archive = _.pickBy(this.archive, (value, key) => key.toString() !== carId.toString());
                }
            }
        },
        watch: {
            search(val) {
                this.loading = true;
                const params = new URLSearchParams(this.initialSearchParams);
                params.append("search", val);
                this.axios.get(this.api.ACTIONS.CAPTAINS, {params})
                    .then(res => {
                        const {data} = res.data.data;
                        this.data = data.map(item => ({
                            text: item.first_name + " " + item.last_name + " " + item.username + " " + item.whatsapp_number + " " + item.email,
                            ...item
                        }));
                    })
                    .catch(err => console.log(err))
                    .finally(() => this.loading = false);
            },
            captain_model(val) {
                this.cars = null;
                const carsUrl = this.api.ACTIONS.CAPTAIN_CARS(val);
                this.loading = true;
                this.axios.get(carsUrl).then(
                    ({data}) => {
                        let cars = data.data;
                        if (!(cars instanceof Array))
                            cars = [cars];
                        this.cars = cars;
                    }
                ).finally(() => this.loading = false);
            },
            model(val) {
                this.$emit('input',val);
            }
        },
    }
</script>

<style scoped>

</style>